import { Routes, Route, Navigate } from "react-router-dom";


import InternationalFreights from "./InternationalFreights";

const internationalFreightRoutes = [
    {routeName: 'air-freight' , component: <InternationalFreights/>},
    {routeName: 'road-freight' , component: <InternationalFreights/>},
    {routeName: 'sea-freight' , component: <InternationalFreights/>},
    {routeName: 'custom-brokrage' , component: <InternationalFreights/>},    
];

const InternationalFreightRoutes = () => {
    return (
    <Routes>
       {internationalFreightRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default InternationalFreightRoutes;